import React, { useEffect, useState } from 'react';
import { UseFormMethods } from 'react-hook-form';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import AdditionalDamages from 'src/models/AdditionalDamages';
import IndexReferenceType from 'src/models/IndexReferenceType';

const DAMAGE_TYPE = [
    { value: 'MISC', label: 'MISC' },
    { value: 'AGEA', label: 'AGEA' },
    { value: 'TAR', label: 'TAR' },
    { value: 'TWS', label: 'TWS' },
];

interface IAdditionalDamagesListProps extends Partial<Pick<UseFormMethods, 'getValues' | 'setValue' | 'register' | 'errors'>> {
    additionalDamages: Array<AdditionalDamages>;
    measurementTypes: Array<IndexReferenceType>;
    namePrefix: string;
    costApplied: Array<{ value: string, label: string}>;
    calculateTotals?: boolean;
    netLength: number;
    isReadonly?: boolean;
    rowPayOptions: { value: string; label: string; }[];

    handleTotals: () => void;
    handleRemoveDamages?: (index: number) => void;
    onAddDamages: () => void;
    calcRowTotal?: (measurementType: string, paymentAmount: number, grossAcres: number, measurementTypesList: Array<IndexReferenceType>) => number;
}

const AdditionalDamagesList = (props: IAdditionalDamagesListProps) => {
    const [addlDamages, setAddlDamages] = useState<Array<AdditionalDamages>>([]);

    useEffect(() => {
        setAddlDamages(props.additionalDamages ?? []);
    }, [props.additionalDamages]);

    useEffect(() => {
        for (let i = 0; i < addlDamages?.length; i++) {
            handleTotals(i);
        }
    }, [props.netLength]);

    useEffect(() => {
        if (!!props.measurementTypes && addlDamages.length > 0) {
            for (let i = 0; i < addlDamages.length; i++) {
                handleTotals(i);
            }
        }
    }, [props.measurementTypes, addlDamages]);

    const handleTotals = (index: number) => {
        if (!!props.measurementTypes && props.calculateTotals === true) {
            let rep = props.getValues();
            let repReference = rep;
            let sections = props.namePrefix.split('.');
            for (let s of sections) {
                if (s.indexOf('[') > -1) {
                    let arrRef = s.indexOf('[');
                    let arrIndex = parseInt(s.substring(arrRef + 1, s.length - 1), 10);
                    repReference = repReference?.[s.substring(0, arrRef)];
                    repReference = repReference?.[arrIndex];
                } else {
                    repReference = repReference?.[s];
                }
            }
    
            let cost = parseFloat(repReference?.[index]?.cost);
            if (!isNaN(cost) && repReference?.[index]?.costType && props.calcRowTotal !== undefined) {
                let totalCost = props.calcRowTotal(repReference?.[index]?.costType, cost, props.netLength, props.measurementTypes);
                props.setValue(`${props.namePrefix}[${index}].totalCost`, totalCost);
            }
        }

        props.handleTotals();
    };
    
    return (
        <div>
            {addlDamages?.length > 0 ? addlDamages.map((damages: AdditionalDamages, index: number) => {
                return (
                    <div className="form-row" key={`extension-${index}`}>
                        <div className="mr-1" hidden={true}>
                            <RHFInputBox label="" name={`${props.namePrefix}[${index}].id`} register={props.register} errors={props.errors} disabled={true} />
                            <RHFInputBox label="" name={`${props.namePrefix}[${index}].contractLookupId`} register={props.register} errors={props.errors} disabled={true} />
                            <RHFInputBox label="" name={`${props.namePrefix}[${index}].agreementTypeId`} register={props.register} errors={props.errors} disabled={true} />
                            <RHFInputBox label="" name={`${props.namePrefix}[${index}].createdByUserId`} register={props.register} errors={props.errors} disabled={true} />
                            <RHFInputBox label="" name={`${props.namePrefix}[${index}].modifiedByUserId`} register={props.register} errors={props.errors} disabled={true} />
                            <RHFInputBox label="" name={`${props.namePrefix}[${index}].createdDate`} register={props.register} errors={props.errors} disabled={true} />
                            <RHFInputBox label="" name={`${props.namePrefix}[${index}].modifiedDate`} register={props.register} errors={props.errors} disabled={true} />
                        </div>
                        <RHFSelect
                            label="Damage Type"
                            name={`${props.namePrefix}[${index}].damageType`}
                            options={DAMAGE_TYPE}
                            register={props.register}
                            errors={props.errors}
                            disabled={props.isReadonly}
                            bodyStyle={{ width: '10%' }}
                            style={{ width: '100%' }}
                        />
                        <RHFInputBox
                            label="Description"
                            name={`${props.namePrefix}[${index}].description`}
                            register={props.register}
                            errors={props.errors}
                            disabled={props.isReadonly}
                            bodyStyle={{ width: '50%' }}
                            style={{ width: '100%' }}
                        />
                        <RHFInputBox
                            label="Cost"
                            name={`${props.namePrefix}[${index}].cost`}
                            register={props.register}
                            type="number"
                            errors={props.errors}
                            onChange={() => handleTotals(index)}
                            step={0.0001}
                            disabled={props.isReadonly}
                            bodyStyle={{ width: '10%' }}
                            style={{ width: '100%' }}
                        />
                        <RHFSelect
                            label=" "
                            name={`${props.namePrefix}[${index}].costType`}
                            options={props.rowPayOptions}
                            register={props.register}
                            errors={props.errors}
                            disabled={props.isReadonly}
                            onChange={() => handleTotals(index)}
                            bodyStyle={{ width: '10%' }}
                            style={{ width: '100%' }}
                        />
                        <RHFInputBox
                            label="Cost"
                            name={`${props.namePrefix}[${index}].totalCost`}
                            register={props.register}
                            type="number"
                            errors={props.errors}
                            step={0.0001}
                            disabled={true}
                            bodyStyle={{ width: '5%' }}
                            style={{ width: '100%' }}
                        />

                        <RHFSelect
                            label="Cost Applied"
                            name={`${props.namePrefix}[${index}].costApplied`}
                            options={props.costApplied}
                            register={props.register}
                            errors={props.errors}
                            disabled={props.isReadonly}
                            bodyStyle={{ width: '10%' }}
                            style={{ width: '100%' }}
                            onChange={props.handleTotals}
                        />

                        <div style={{ width: '5%' }}>
                            <button
                                type="button"
                                onClick={() => props.handleRemoveDamages?.(index)}
                                style={{ cursor: 'pointer', color: '#c23030', marginLeft: '1rem', fontWeight: 'bold', background: 'transparent', border: 'none' }}
                                title="Remove"
                                aria-label="Remove additional damages row"
                            >                                    
                                ×
                            </button>
                        </div>
                    </div>
                );
            }) : <div />}
            <div style={{ marginTop: '2rem' }}>
                <Button text="Add Damages" onClick={props.onAddDamages} intent="primary" />
            </div>
        </div>
    );
};

export default AdditionalDamagesList;


// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/AdditionalDamagesList.tsx